//Module suppliers
export const URL_BASE_EXPEDIENT_SUPPLIER = 'expedientsbysupplier';
export const REQUEST_EXPEDIENT_SUPPLIER = 'ExpedientSupplier';
export const MODULE_SUPPLIERS = 'MODULE_SUPPLIERS';